import { useTranslation } from 'react-i18next';

const ONE_MINUTE = 60;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;
const ONE_WEEK = ONE_DAY * 7;
type Unit = 'minute' | 'hour' | 'day' | 'week'

const timeUnitToValue: Map<Unit, number> = new Map([
    ['minute', ONE_MINUTE],
    ['hour', ONE_HOUR],
    ['day', ONE_DAY],
    ['week', ONE_WEEK],
]);

const useFormatter = () => {
    const { t } = useTranslation();

    const formatDate = (date: string | undefined) => {

        if (!date) return '';

        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) return '';

        return new Intl.DateTimeFormat(navigator.language, {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        }).format(parsedDate);
    };

    const formatDateWithTime = (date: string | undefined) => {

        if (!date) return '';

        return t('intlDateTime', {
            val: new Date(date),
            formatParams: {
                val: {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                },
            },
        });
    };

    const formatTime = (date: string | undefined) => {

        if (!date) return '';

        return t('intlDateTime', {
            val: new Date(date),
            formatParams: {
                val: {
                    hour: 'numeric',
                    minute: 'numeric',
                },
            },
        });
    };
    const formatLastActivityDate = (date: string | undefined) => {

        if (!date) return '';

        let unit: Unit = 'minute';
        const diffInSecond = (Date.now() - new Date(date).getTime()) / 1000;

        const getNumberOfUnit = (diff: number, timeUnit: Unit) => {
            return Math.floor(diff / timeUnitToValue.get(timeUnit)!);
        };

        switch (true) {
            //https://stackoverflow.com/questions/6665997/switch-statement-for-greater-than-less-than => switch-range2
            case (diffInSecond >= ONE_WEEK): unit = 'week'; break;
            case (diffInSecond >= ONE_DAY): unit = 'day'; break;
            case (diffInSecond >= ONE_HOUR): unit = 'hour'; break;
            case (diffInSecond >= ONE_MINUTE): unit = 'minute'; break;
        }

        return t(`${unit}RelativeTimeOption`, {
            val: getNumberOfUnit(diffInSecond, unit) * -1,
        });
    };

    return { formatDate, formatTime, formatLastActivityDate, formatDateWithTime };
};


export default useFormatter;